module.exports = __webpack_public_path__ + "static/media/family.4d4daf6f.jpg";